module.exports = __webpack_public_path__ + "img/logo_jl.3b82ecc3.png";